import React from "react";
import styled from "styled-components";
import { Typography } from "@shared/ui/Typography";

interface IProps {
  label: string;
  children: React.ReactNode;
  subLabel?: string;
  className?: string;
}

export function HorizontalFormField({
  label,
  subLabel,
  className,
  children,
}: IProps) {
  return (
    <StyledView className={className}>
      <StyledTitleWrapper>
        <StyledLabel tag="span" color="metallic_silver" weight={500}>
          {label}
        </StyledLabel>
        <StyledSubLabel tag="span" color="metallic_silver">
          {subLabel}
        </StyledSubLabel>
      </StyledTitleWrapper>
      <StyledField>{children}</StyledField>
    </StyledView>
  );
}

const StyledView = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.8fr;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    grid-template-columns: 1fr;
  }
`;

const StyledTitleWrapper = styled.div`
  padding: 1.6rem 0;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    padding: 0;
    margin-bottom: 0.2rem;
  }
`;

const StyledField = styled.div``;

const StyledLabel = styled(Typography)`
  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.basic_black};
  }
`;

const StyledSubLabel = styled(Typography)`
  opacity: 0.5;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    font-size: 1.2rem;
    opacity: 1;
    color: ${(props) => props.theme.colors.basic_black};
  }
`;
